import { Waves } from "lucide-react";
import Link from "next/link";

export function LegalHeader() {
  return (
    <header className="legal-header">
      <Link className="legal-header-brand" href="/" aria-label="Boardblend home">
        <span className="brand-mark" aria-hidden="true">
          <Waves />
        </span>
        <strong>Boardblend</strong>
      </Link>
      <nav aria-label="Main navigation">
        <Link href="/resources">Resources</Link>
        <Link href="/#pricing">Pricing</Link>
        <Link href="/sign-in">Sign in</Link>
      </nav>
    </header>
  );
}
